import React from "react";
import { RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { submit, isInvalid } from "redux-form";
import { WithStyles, withStyles, Grid } from "material-ui";
import BlueRibbon from "../../components/BlueRibbon/BlueRibbon";

import {
    SetHeader,
    ShowLogo,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
} from "../../ducks/common";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import {
    SetActionButtonAndShow,
    SetShowActionButton,
    ResetActionButtonClicked,
    actionButtonClicked,
    SetActionButtonDisabled,
    actionButtonDisabled,
} from "../../ducks/actionbutton";
import {
    getAllLoans,
    getAllLoansData,
    getEditTypeId,
    Loans,
    saveLoanEditForm,
    getEditTypeIdList,
    getLoanChangeRequestTypes,
} from "../../ducks/loan";
import { LoanEditInfoDto } from "../../util/DTOs/LoanDtos";

import LoanEditForm, { LoanEditFormData } from "./components/loanEditForm";

const styles = {} as React.CSSProperties;

interface LoanEditPageProps extends RouteComponentProps<{ id: number }> {}

interface LoanEditPageReduxProps {
    loansData: Loans;
    actionButtonClicked: boolean;
    editTypeId: number;
    editTypeIdList: Array<LoanEditInfoDto>;
    actionButtonDisabled: boolean;
    invalid: boolean;
}

interface LoanEditPageDispatchProps {
    submitLoanForm: () => void;
    saveLoanFormData: (data: LoanEditFormData) => void;
    getLoansData: () => void;
    setHeaderValue: (header: string) => void;
    showLogo: (show: boolean) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    setShowActionButton: (show: boolean) => void;
    setActionButton: (text: string) => void;
    resetActionButtonClick: () => void;
    disableActionButton: (disabled: boolean) => void;
    getEditTypes: () => void;
}

interface LoanEditPageState {}

type LoanEditPageConnectedProps = LoanEditPageProps &
    LoanEditPageReduxProps &
    LoanEditPageDispatchProps;

type LoanEditPagePropsWithStyles = LoanEditPageConnectedProps & WithStyles<"">;

class LoanEditPage extends React.Component<
    LoanEditPagePropsWithStyles,
    LoanEditPageState
> {
    componentDidMount() {
        this.props.setHeaderValue("Hae muutosta");
        this.props.showLogo(false);
        this.props.setBackButton("");
        //this.props.setBackButton(`/loan/${this.props.match.params.id}`);
        this.props.setActionButton("Lähetä");
        this.props.getLoansData();
        this.props.getEditTypes();
    }

    componentWillUnmount() {
        this.props.showLogo(true);
        this.props.hideBackButton();
        this.props.setShowActionButton(false);
    }

    componentWillReceiveProps(nextProps: LoanEditPagePropsWithStyles) {
        if (this.props.invalid !== nextProps.invalid) {
            if (nextProps.invalid && !nextProps.actionButtonDisabled) {
                this.props.disableActionButton(true);
            } else if (!nextProps.invalid && nextProps.actionButtonDisabled) {
                this.props.disableActionButton(false);
            }
        }

        if (nextProps.actionButtonClicked === true) {
            this.props.submitLoanForm();
        }
    }

    save = async (data: LoanEditFormData) => {
        try {
            data.loanNumber = this.props.loansData[data.loanId].loanNumber;

            await this.props.saveLoanFormData(data);
            this.props.resetActionButtonClick();

            this.props.history.push(`/loan/edit/requestsent`);
        } catch (error) {
            throw error;
        } finally {
            this.props.resetActionButtonClick();
        }
    };

    render() {
        const { classes } = this.props;
        const ribbonText =
            "Tällä lomakkeella voit pyytää lainasi lyhennyssuunnitelman muuttamista tai muuta lainaehtojen muutosta. Huomioithan, että muutos edellyttää Hypon erillistä päätöstä. Hakijan luottotiedot hankitaan luottotietorekisteristä ja hakijan tulo- ja kokonaisvastuutiedot hankitaan positiivisesta luottotietorekisteristä.";

        const loans = Object.keys(this.props.loansData).map((key) => {
            const loan = this.props.loansData[key];
            const label = loan.loanName
                ? `${loan.loanName} - ${loan.loanNumber}`
                : `${loan.loanNumber}`;
            return { label: label, value: key };
        });

        const editTypeIdList = Object.keys(this.props.editTypeIdList).map(
            (key) => {
                const editType = this.props.editTypeIdList[key];
                return {
                    label: editType.name,
                    value: editType.editTypeId,
                    price: editType.price,
                };
            }
        );

        return (
            <div className="page-container">
                <BlueRibbon text={ribbonText} color={"#0069B4"} />
                <LoanEditForm
                    editTypeId={this.props.editTypeId}
                    loansList={loans}
                    editTypeIdList={editTypeIdList}
                    initialValues={{ loanId: this.props.match.params.id }}
                    form="loanEditForm"
                    onSubmit={this.save}
                />
            </div>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: LoanEditPagePropsWithStyles
): LoanEditPageReduxProps => {
    const disabled = actionButtonDisabled(state);

    return {
        loansData: getAllLoansData(state),
        actionButtonClicked: actionButtonClicked(state),
        editTypeId: getEditTypeId(state),
        editTypeIdList: getEditTypeIdList(state),
        actionButtonDisabled: disabled,
        invalid: isInvalid("loanEditForm")(state),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): LoanEditPageDispatchProps => {
    return {
        submitLoanForm: async () => {
            await dispatch(submit("loanEditForm"));
        },
        saveLoanFormData: async (data: LoanEditFormData) => {
            await dispatch(saveLoanEditForm(data));
        },
        getLoansData: () => {
            dispatch(getAllLoans());
        },
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        showLogo: (show: boolean) => {
            return dispatch(ShowLogo(show));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        setShowActionButton: (show: boolean) => {
            dispatch(SetShowActionButton(show));
        },
        setActionButton: (text: string) => {
            dispatch(SetActionButtonAndShow({ text }));
        },
        resetActionButtonClick: () => {
            dispatch(ResetActionButtonClicked());
        },
        disableActionButton: (disabled: boolean) => {
            dispatch(SetActionButtonDisabled(disabled));
        },
        getEditTypes: () => {
            dispatch(getLoanChangeRequestTypes());
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(LoanEditPage));



// WEBPACK FOOTER //
// ./src/views/loan/LoanEditPage.tsx